// Clinic Configuration for Dentist in Louisville
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Louisville",
  clinicId: "dentistinlouisville",
  clinicUrl: "https://dentistinlouisville.com",
  // Contact Information
  phoneNumber: "502-239-9751",
  phoneNumberRaw: "+15022399751", // For tel: and sms: links
  email: "dentalcare@dentistinlouisville.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinlouisville&agentId=2ccb03ad-94ee-4916-a3d1-3697bca0fe70",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinlouisville/voice",

  // Location
  address: "6826 Bardstown Road, Louisville, Kentucky, 40291, USA",
  addressShort: "6826 Bardstown Road, Louisville, Kentucky, 40291",
  city: "LOUISVILLE",
  hcity: "LOUISVILLE",
  state: "Kentucky",
  stateShortForm: "KY",
  PostalCode: "40291",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/m76QtysK96poeUWy7",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d363450.0118906711!2d-85.588281!3d38.147216!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8869a74b59989351%3A0x968e9533325f1250!2sDentist%20in%20Louisville!5e1!3m2!1sen!2sin!4v1756800367941!5m2!1sen!2sin',
  iframeTitle: "Dentist in Louisville",

  //membership
  membership: "https://member.kleer.com/?slug=AH4A",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/DentistinLouisville",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-louisville?utm_source=practice&utm_medium=email&m=66114",


  // Analytics
  gaMeasurementId: "G-5SBWFQJSPK",
  clarityProjectId: "prdfvmoubk",

  // Google Ads — direct conversion tracking
  googleAdsId: "AW-16691172061",
  googleAdsConversions: {
    // Primary — used for Smart Bidding optimization
    "phone_call_click": "AW-16691172061/kV3JCI7Vw5QcEN2l_JY-",
    "contact_form_success": "AW-16691172061/y_SoCISywoYcEN2l_JY-",
    "call_back_success": "AW-16691172061/a2ssCNW3roYcEN2l_JY-",
    "chatbot_phone_click": "AW-16691172061/96IGCKrqt5QcEN2l_JY-",
    "chatbot_voice_call": "AW-16691172061/OXncCK3qt5QcEN2l_JY-",
    "book_appointment_success": "AW-16691172061/HLSGCNK3roYcEN2l_JY-",
    "Confirm-Booking": "AW-16691172061/ZKf5CLrot5QcEN2l_JY-",
    "Submit-Payment": "AW-16691172061/2TRVCLDqt5QcEN2l_JY-",
    // Secondary — observation/reporting only
    "sms_click": "AW-16691172061/uS7mCIL6zJQcEN2l_JY-",
    "directions_click": "AW-16691172061/Nqz8CIfnzJQcEN2l_JY-",
    "email_click": "AW-16691172061/GOvvCIf_zJQcEN2l_JY-",
    "map_click": "AW-16691172061/2Ul-COH5zJQcEN2l_JY-",
    "social_media_click": "AW-16691172061/oE8rCLXYw5QcEN2l_JY-",
    "financing_click": "AW-16691172061/TfhgCOfrt5QcEN2l_JY-",
    "membership_click": "AW-16691172061/RPpPCOrrt5QcEN2l_JY-",
    "outbound_link_click": "AW-16691172061/HwHYCKqBzZQcEN2l_JY-",
    "chat_send": "AW-16691172061/kjOnCM3pt5QcEN2l_JY-",
    "chatbot_quick_action": "AW-16691172061/casRCO3rt5QcEN2l_JY-",
    "chatbot_insurance_upload": "AW-16691172061/PFVFCPDrt5QcEN2l_JY-",
  } as Record<string, string>,

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinlouisville",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinlouisville",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinlouisville",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistinlouisville.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/DentistinLouisville",
    instagram: "https://www.instagram.com/dentistinlouisville/",
    twitter: "https://x.com/Dt_Louisville",
    linkedin: "https://www.linkedin.com/company/108108312/admin/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BZHzZHS4UQLaEyel%2BGoze8g%3D%3D",
    youtube: "https://www.youtube.com/@DentistinLouisvilleKY",
  },
  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/13129422478007477118/profile?hl=en-GB&fid=10848772599503065680",
    facebook: "https://www.facebook.com/dentistinlouisville.official/",
    yelp: "https://www.yelp.com/biz/dentist-in-louisville-louisville",
  },

  // Open Dental Configuration
  defaultProvNum: 199,
  defaultOpNum: 4597,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 4598,
      AppointmentTypeNum: 5
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 4597,
      AppointmentTypeNum: 3
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 4597,
      AppointmentTypeNum: 16
    }
  ],



  // Twilio Configuration
  twilioPhoneNumber: "15024538690",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;  
